import { render, staticRenderFns } from "./UserRecentTransactionsList.vue?vue&type=template&id=59ecd6ba"
import script from "./UserRecentTransactionsList.vue?vue&type=script&lang=js"
export * from "./UserRecentTransactionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports